export function uniquePhotos(photos?: string[] | null): string[] {
  const seen = new Set<string>();
  const unique: string[] = [];

  (photos || []).forEach(photo => {
    const trimmed = photo?.trim();
    if (!trimmed) return;

    let key = trimmed;
    try {
      const url = new URL(trimmed);
      key = `${url.origin}${url.pathname}`.toLowerCase();
    } catch {
      key = trimmed.toLowerCase();
    }

    if (!seen.has(key)) {
      seen.add(key);
      unique.push(trimmed);
    }
  });

  return unique;
}
